import React, { useState } from 'react';
import { ChevronDown, ArrowRight } from 'lucide-react';

const FAQItem = ({ question, answer, isOpen, onClick }) => {
  return (
    <div className="border-b border-gray-200">
      <button
        className="w-full py-6 flex justify-between items-center text-left"
        onClick={onClick}
      >
        <h3 className="text-lg font-semibold text-[#113262] pr-8">{question}</h3>
        <ChevronDown 
          className={`w-5 h-5 text-[#F49611] transform transition-transform duration-200 ${
            isOpen ? 'rotate-180' : ''
          }`}
        />
      </button>
      <div 
        className={`overflow-hidden transition-all duration-300 ${
          isOpen ? 'max-h-96 pb-6' : 'max-h-0'
        }`}
      >
        <p className="text-gray-600">{answer}</p>
      </div>
    </div>
  );
};

const AIFAQ = () => {
  const [openIndex, setOpenIndex] = useState(0);

  const faqs = [
    {
      question: "What is the AI-Driven Investment Portfolio Management system?",
      answer: "Our AI-Driven Investment Portfolio Management system combines deep investing wisdom with cutting-edge artificial intelligence to build high-quality portfolios for wealth creation and capital preservation. It's powered by our proprietary Roots & Wings investment philosophy and advanced data science, ensuring your portfolio is built on solid foundations while maintaining growth potential."
    },
    {
      question: "How does the AI system analyze investment opportunities?",
      answer: "Our AI system analyzes thousands of listed companies, scanning decades of financial data and simulating millions of scenarios to assess performance in different macro environments. It uses advanced machine learning models that continuously optimize for portfolio performance, going beyond traditional analysis to detect non-linear correlations that others might miss."
    },
    {
      question: "What makes your AI investment approach different from others?",
      answer: "Our approach is unique because it combines the stability of strong businesses (Roots) with the scalability of consistent growth (Wings). We use custom-built RAG pipelines to digest unstructured data from research reports, earnings calls, and more, extracting insights that traditional methods can't. Our system is hosted on a secure, on-premise system to protect your data and insights."
    },
    {
      question: "How does the system ensure portfolio stability?",
      answer: "Our system uses dimensionality reduction through refined Principal Component Analysis (PCA) to distill large datasets and focus on factors that truly move company performance. It continuously monitors markets and company-specific indicators in real-time, triggering alerts based on pre-set thresholds to enable timely action without emotional bias."
    },
    {
      question: "What kind of insights does your AI system provide?",
      answer: "Our AI system provides comprehensive insights by analyzing both structured and unstructured data. It maps complex relationships between financial variables, detects non-linear correlations, and provides smart scoring models that help us build diversified portfolios with low drawdowns and faster recovery potential."
    },
    {
      question: "How does this approach benefit individual investors?",
      answer: "Our AI-driven approach provides three key benefits: Clarity - you know exactly why you hold each investment; Confidence - your decisions are backed by data; and Consistency - your wealth grows with portfolios that adapt and evolve. As Warren Buffett noted, 'Risk comes from not knowing what you're doing.' Our system ensures you always know what you're investing in and why."
    }
  ];

  return (
    <div className="max-w-6xl w-full mx-auto px-4 sm:px-6 lg:px-8 py-4 md:py-6 lg:py-8">
      <div className="flex flex-col md:flex-row gap-16">
        <div className="md:w-1/3">
          <div className="sticky top-8">
            <div className="w-12 h-0.5 bg-[#F49611] mb-3"></div>
            <h2 className="text-2xl md:text-3xl lg:text-4xl font-bold text-[#113262] mb-4">
              Understanding the AI-Driven Investment Portfolio Management System
            </h2>
            <p className="text-gray-600 mb-8">
              Discover how our advanced AI system combines deep investing wisdom with cutting-edge technology to build high-quality portfolios that balance stability and growth potential.
            </p>
            <a href="/meeting" className="flex items-center text-[#F49611] font-semibold hover:gap-2 transition-all">
              <span>Speak With An Expert</span>
              <ArrowRight className="w-5 h-5 ml-2" />
            </a>
          </div>
        </div>
        <div className="md:w-2/3">
          {faqs.map((faq, index) => (
            <FAQItem
              key={index}
              question={faq.question}
              answer={faq.answer}
              isOpen={index === openIndex}
              onClick={() => setOpenIndex(index === openIndex ? -1 : index)}
            />
          ))}
        </div>
      </div>
    </div>
  );
};

export default AIFAQ;